export default "__VITE_ASSET__OJT0lvHB__"